import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import connect from "@classdojo/web/utils/hoc/connect";
import { AT } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import * as React from "react";
import { Link } from "react-router-dom";
import { displayClose as displayCloseActionCreator, selectDisplayOn, selectPaired } from "src/pods/realtime";

interface ContainerProps {
  onRequestStart?: VoidFunction;
  onRequestStop?: VoidFunction;
  className?: string;
}

interface ViewProps {
  isConnected?: boolean;
  isCasting?: boolean;
  displayClose?: VoidFunction;
}

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class CastControl extends React.Component<ContainerProps & ViewProps> {
  render() {
    const { className, displayClose, isConnected, isCasting, onRequestStart } = this.props;
    const onRequestStop = this.props.onRequestStop || displayClose;

    if (isConnected) {
      if (isCasting) {
        return (
          <section
            sx={{
              ...controlStyle,
              ...{
                backgroundColor: "dt_background_tertiary",
                color: "dt_content_plus",
              },
            }}
            className={className}
          >
            <span>
              <AT>Casting to computer</AT>
            </span>
            <a
              data-name="cast_control:render:cast_control_stop"
              sx={{ ...castButtonStyle, color: "dt_content_danger" }}
              onClick={onRequestStop}
            >
              <AT>Stop</AT>
            </a>
          </section>
        );
      } else {
        return (
          <section sx={{ ...controlStyle }} className={className}>
            <span>
              <AT>Computer detected</AT>
            </span>
            <a data-name="cast_control:render:cast_control_start" sx={castButtonStyle} onClick={onRequestStart}>
              <AT>Start DojoCast</AT>
            </a>
          </section>
        );
      }
    } else {
      const helpLinkStyle: ThemeUIStyleObject = { ...castButtonStyle, ...learnMoreStyle };

      return (
        <section sx={{ ...controlStyle }} className={className}>
          <span>
            <AT>No computer connected!</AT>
          </span>
          <Link to="/apps/help/what-is-dojocast" sx={helpLinkStyle}>
            <AT>Learn more</AT>
          </Link>
        </section>
      );
    }
  }
}

const mapStateToProps = { isConnected: selectPaired, isCasting: selectDisplayOn };
const mapDispatchToProps = { displayClose: displayCloseActionCreator };
const CastControlContainer = connect(mapStateToProps, mapDispatchToProps)(CastControl);
export default CastControlContainer;

const learnMoreStyle: ThemeUIStyleObject = {
  marginLeft: "auto",
  color: "dt_content_tertiary",
  textTransform: "uppercase",
  fontSize: 12,
  fontWeight: "bold",
};

const controlStyle: ThemeUIStyleObject = {
  height: "48px",
  lineHeight: "48px",
  padding: RAW_cssValue("0 14px"),
  fontSize: "16px",
  fontWeight: 600,
  backgroundColor: "dt_background_secondary",
  color: "dt_content_tertiary",
};

const castButtonStyle: ThemeUIStyleObject = {
  float: "right",
  textDecoration: "none",
  textTransform: "uppercase",
  fontSize: "0.75em",
  fontWeight: 800,
  color: "dt_content_plus",
};
